import React from "react";
import "./index.css";

const LoadingScreen: React.FC = () => {
  return (
    <div className="loading-screen">
      <div className="loading-spinner"></div>
      <div className="loading-text">Loading allocations...</div>
      <p className="loading-subtext">Preparing your cart allocation data</p>
    </div>
  );
};

export default LoadingScreen;